import { useState, useRef, useEffect } from 'react';
import { Button } from 'react-aria-components';



const Collapsible = (): JSX.Element => {

	const [ isOpen, setIsOpen ] = useState(false);
	const contentRef = useRef<HTMLDivElement | null>(null);

	
	useEffect(() => {
		if (isOpen && contentRef && contentRef.current) {
			setTimeout(() => contentRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ isOpen, contentRef ]);

	
	return (
		<div className='collar-info-section'>
			
			<Button className={`collapsible-collar-info-button disable-selection${isOpen ? ' active' : ''}`} onPress={() => setIsOpen(!isOpen)}>
				<p>Potřebuji pomoct při výběru <span>+</span></p>
			</Button>
			
			<div
				className='collapsible-collar-info-content'
				style={{ maxHeight: isOpen && contentRef && contentRef.current ? `${contentRef.current.scrollHeight}px` : '0'}}
				ref={contentRef}>
				
				<div className='collar-info-elements'>
					<p>LÍMEC SE ZAPÍNÁNÍM (Vyberte v&nbsp;případě, že&nbsp;Vaše zvíře je&nbsp;klidné a&nbsp;není takříkajíc vynalézavé, tedy není důvod se&nbsp;domnívat, že&nbsp;by&nbsp;mělo mít tendenci jevit zvýšený zájem o&nbsp;zapínání límce (hrát si s&nbsp;ním, snažit se&nbsp;jej kousat...). V&nbsp;tomto provedení límec budete zapínat kolem krku, hodí se&nbsp;tak&nbsp;pro&nbsp;jedince, kteří netolerují navlékání přes hlavu.)</p>
					<p>LÍMEC BEZ ZAPÍNÁNÍ (Vyberte v&nbsp;případě, že&nbsp;Vaše zvíře je&nbsp;vynalézavé a&nbsp;existuje důvod se&nbsp;domnívat, že&nbsp;bude jevit o&nbsp;zapínání límce zvýšený zájem (hrát si s&nbsp;ním, snažit se&nbsp;jej kousat...). Límec v&nbsp;tomto provedení budete zvířeti navlékat přes hlavu, což&nbsp;většině chlupáčů nečiní potíže, i&nbsp;přesto ale tento fakt vezměte v&nbsp;úvahu.). <span>Pokud má Váš pes větší lebku, než obvod krku, tato&nbsp;varianta není vhodná, límec by&nbsp;nepřetáhl.</span></p>
				</div>
			</div>
		
		</div>
	);
}

export default Collapsible;